
export default function RecruitFooter() {
  return (
    <footer className="bg-teal-600 text-white py-10 sm:py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg overflow-hidden shadow-md bg-white flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/0f43beb23aaca34fe525f322afdb3a4e/91f45852d6469a87479e767848617524.jpeg"
                  alt="Refresh Labo ロゴ"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-lg sm:text-xl font-bold">Refresh Labo</span>
            </div>
            <p className="text-xs sm:text-sm text-teal-50 leading-relaxed">
              賃貸に特化した原状回復工事をメインに、在宅、空室ハウスクリーニング・クロス張替え・床張替えなどを行っております。
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">サービス</h3>
            <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-teal-50">
              <li>
                <a href="/#services" className="hover:text-white transition-colors cursor-pointer">ハウスクリーニング</a>
              </li>
              <li>
                <a href="/#services" className="hover:text-white transition-colors cursor-pointer">クロス張替え</a>
              </li>
              <li>
                <a href="/#services" className="hover:text-white transition-colors cursor-pointer">床張替え</a>
              </li>
              <li>
                <a href="/#services" className="hover:text-white transition-colors cursor-pointer">原状回復工事</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">リンク</h3>
            <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-teal-50">
              <li>
                <a href="/" className="hover:text-white transition-colors cursor-pointer">ホーム</a>
              </li>
              <li>
                <a href="/#about" className="hover:text-white transition-colors cursor-pointer">会社概要</a>
              </li>
              <li>
                <a href="/partner" className="hover:text-white transition-colors cursor-pointer">協力会社募集</a>
              </li>
              <li>
                <a href="/recruit" className="hover:text-white transition-colors cursor-pointer">正社員募集</a>
              </li>
              <li>
                <a href="/#contact" className="hover:text-white transition-colors cursor-pointer">お問い合わせ</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm text-teal-50">© 2025 Refresh Labo. All rights reserved.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-xs sm:text-sm text-teal-50 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
